/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import Page from 'components/Page';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import Loading from 'wrappers/Loading';
import { Vigencia } from '../../components/Vigencia/Vigencia';
import { CYBER } from './constantes/general';

const API = ApiKeyFetch.instance();

export const CyberVigencia = ({ history, addWarningToast, qParams: { idPoliza } }) => {
  const [loading, setLoading] = useState(true);

  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [preload, setPreload] = useState(null);
  useNavbarContext(PRODUCTOS.CYBER);
  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit } = methods;

  const solicitarRangoVigencia = async () => {
    setLoading(true);
    const Data = { idPoliza };

    const respRangosVigencia = await API.post(URLS_PHP_7.emision.generarVigencia, Data);
    if (respRangosVigencia?.transaccion === true) {
      setFechaInicio(respRangosVigencia?.fechaInicio);
      setFechaFin(respRangosVigencia?.fechaFin);

      if (respRangosVigencia?.fechaInicioVigencia && respRangosVigencia?.fechaInicioVigencia !== '') {
        setPreload(new Date(respRangosVigencia?.fechaInicioVigencia + ' 12:00:00'));
        methods.reset({
          fechaInicioVigencia: new Date(respRangosVigencia?.fechaInicioVigencia + ' 12:00:00'),
        });
      }
    }
    setLoading(false);
    return respRangosVigencia;
  };
  useEffect(() => {
    solicitarRangoVigencia();
  }, []);

  const onSubmit = async (data) => {
    setLoading(true);
    const Data = { ...data, idPoliza };
    const respuestaGuardar = await API.post(URLS_PHP_7.emision.guardarVigencia, Data);
    if (respuestaGuardar?.transaccion === true) {
      history.push(`${CYBER.urls.pago}?idPoliza=${idPoliza}`);
      methods.reset(data);
    } else {
      if (respuestaGuardar?.msgError) {
        addWarningToast(respuestaGuardar?.msgError, { autoDismiss: false });
      }
    }
    setLoading(false);
  };

  const onSubmitError = (error) => {
    console.error(error);
  };

  const onClickSiguiente = () => {
    handleSubmit(onSubmit, onSubmitError)();
  };

  const regresar = () => {
    history.push(`${CYBER.urls.asegurado}?idPoliza=${idPoliza}`);
  };

  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          {/* <BreadCrumb
            {...PASOS_BREADCRUMBS[PRODUCTOS.LINEAS_FINANCIERAS].breadCrumb}
            showPaths={false}
          /> */}

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.CYBER].breadCrumbPasosEmision[6]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.CYBER].pasosEmision}
          />
          <div className="row justify-content-center">
            <div className="col-md-10 card-login-mex py-5 text-center">
              <h1 className="display-4 font-mex">Inicio de vigencia de la póliza</h1>
              <FormProvider {...methods}>
                <Vigencia {...{ fechaInicio, fechaFin, preload, onClickSiguiente, regresar }} />
              </FormProvider>
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};
